import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// Components 
import Box from '@mui/material/Box';
import FreeTrial from './FreeTrial';
import Subscription from './Subscription';

interface Props { 

}; 

const PlanInfo: React.FC<Props> = ({ }) => {
    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 

    const colors = useAppSelector(state => state.theme.colors); 
    const accountInfo = useAppSelector(state => state.meta.accountInfo); 
    const currentPlan = useAppSelector(state => state.billing.currentPlan); 

    return (
      <Box sx={{ width: '100%', maxWidth: '600px' }}>
        {(currentPlan === 'freeTrial') && <FreeTrial />}
        {(currentPlan === 'subscription') && <Subscription />}
      </Box>
  );
};

export default PlanInfo;